/* eslint-disable @typescript-eslint/no-explicit-any */
import { apiApp, apiPrice } from 'api/request';
import urlApp from 'api/urlApp';
import { size } from 'lodash';
import HttpRequestError from 'utils/HttpRequetsError';

export async function postCreateOrderApi(payload: any): Promise<any> {
  const {data} = await apiApp.post(urlApp.createOrderPath, payload);
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function postUpdateInfoOrderApi(payload: any): Promise<any> {
  const {data} = await apiApp.post(urlApp.updateInfoOrderPath, payload);
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function postCreateOrderNoLoginApi(payload: any): Promise<any> {
  const {data} = await apiApp.post(urlApp.createOrderNoLoginPath, payload);
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function getInfoOrderAPI(payload: any): Promise<any> {
  const {data} = await apiApp.get(`${urlApp.getInfoOrderPath}`, {
    params: payload
  });
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function postGetAllServiceAPI(payload: any): Promise<any> {
  const {data} = await apiPrice.get(urlApp.getAllServicePath, {
    params: payload
  });
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function postGetPriceOrderAPI(payload: any): Promise<any> {
  const {data} = await apiPrice.get(urlApp.getOrderPrice, {
    params: payload
  });
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function getConfigAppApi(payload: any): Promise<any> {
  const {data} = await apiApp.get(`${urlApp.configTypePath}/${payload}`);
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function uploadFileCreateOrderAPI(payload: any): Promise<any> {
  const {data} = await apiApp.post(`${urlApp.uploadFileCreateOrderPath}?address_id=${payload.addID}`, payload.body);
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function getListHistoryFileCreateAPI(payload: any): Promise<any> {
  const {data} = await apiApp.get(`${urlApp.getListHistoryFilePath}`, {
    params: payload
  });
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function getDetailHistoryFileCreateAPI(payload: any): Promise<any> {
  const {data} = await apiApp.get(`${urlApp.getDetailHistoryFilePath}/${payload}`);
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function postCreateOrderFileApi(payload: any): Promise<any> {
  const {data} = await apiApp.post(urlApp.createOrderFilePath, payload);
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function postCreateOrderFileEditApi(payload: any): Promise<any> {
  const {data} = await apiApp.post(urlApp.createOrderFileEditPath, payload);
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function getInfoOrderFileDetailAPI(payload: any): Promise<any> {
  const {data} = await apiApp.get(`${urlApp.getInfoOrderFileDetailPath}/${payload}`);
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}
